import { Vehicule, CalTravel } from './../objects/real-time';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import {Http, Headers} from '@angular/http';
import { GlobalService } from "./global.config";
import {PointInterest, Driver} from "../objects/data-management";
import {Group} from '../objects/real-time'
import {User} from '../objects/real-time'
import {Events } from 'ionic-angular';
@Injectable()
export class DataManagementService {

    pointInterests: PointInterest[] = null;
    currentuser:User;
    groups: Group[] = null;

    selectedGroup:Group = null;
    selectedVehiculeId:number = null;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
       
        this.currentuser= JSON.parse(localStorage.getItem('currentuser'));
    }


    inverseGeoconding(latitude: number, longitude: number, zoom: number): Observable<any> {
        let nominatim_dns = this.globalService.getnominatim_dns();
        return this._http.get(nominatim_dns + '/reverse.php?format=json&lat=' + latitude + '&lon=' + longitude + '&zoom=' + zoom + '&accept-language=fr&addressdetails=1').map(res => res.json());
    }

    getAllPointInterests(): Observable<PointInterest[]> {
        let dns = this.globalService.getDns();
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(dns + 'pointInterests', {headers: headers}).map(res => res.json());
    }
    deletePointInterest(id: number): Observable<Boolean> {
        let dns = this.globalService.getDns();
        let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.delete(dns + 'pointInterests/' + id, {headers: headers}).map(res => res.json());
    }


    addPointInterest(pointInterest: PointInterest): Observable<PointInterest> {
        let dns = this.globalService.getDns();
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(dns + 'pointInterests', pointInterest, {headers: headers}).map(res => res.json());
    }
    updatePointInterest(pointinterest: PointInterest): Observable<PointInterest> {
        let dns = this.globalService.getDns();
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let body = JSON.stringify(pointinterest);
        return this._http.put(dns + 'pointInterests/', pointinterest, {headers:headers}).map(res => res.json());
    }

    getAllGroups(): Observable<Group[]> {
        let dns = this.globalService.getDns();
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(dns + 'groupes/minify', {headers: headers}).map(res => res.json());
    }

    // must exe only if pointInterests not NULL !!!
    getRelativePosition(lat: number, lng: number): string {
        let relativePosition = null;
        this.pointInterests.forEach(pointInterest => {
            let distance = this.distance(lat, lng, pointInterest.coordinate.lat, pointInterest.coordinate.lng);
            if (distance < pointInterest.ray / 1000) {
                relativePosition = pointInterest.name;
            }
            /*if (distance > pointInterest.ray / 1000 && distance < 0.1) {
                relativePosition = Math.round(distance * 1000) + " metre de " + pointInterest.name;
            }*/
            if (distance > pointInterest.ray / 1000 && distance <0.2) {
                let distanceStr = distance.toString().substr(0, 4);
                relativePosition = "à " + distanceStr + " Km de " + pointInterest.name;
            }
        });
        return relativePosition;
    }

    distance(lat1, lon1, lat2, lon2) {
        var p = 0.017453292519943295;    // Math.PI / 180
        var c = Math.cos;
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lon2 - lon1) * p)) / 2;
        var distance = 12742 * Math.asin(Math.sqrt(a));
        return distance;
    }

    getDriverName(driver: Driver) {
        if (driver) {
            if (driver.firstName && driver.lastName) {
                return driver.firstName + ' ' + driver.lastName;
            }
            else if (driver.firstName) {
                return driver.firstName;
            }
            else if (driver.lastName) {
                return driver.lastName;
            }
            else return "anonyme";
        }
        else return "pas de chauffeur";
    }
   
    getDriverPhonenumber(driver:Driver){
        if(driver){
            if(driver.telephone)
            return driver.telephone;
        }
    }
    getCalTravels():Observable<CalTravel[]> {
        let dns = this.globalService.getDns();
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', this.currentuser.token);
        return this._http
          .get(dns + 'vehicules/calTravels', { headers: headers })
          .map(res => res.json());
        }

    getOdoFromRecord(vehicule: Vehicule, accumodo: number) {
        return Math.floor((accumodo + vehicule.odoOffset) * 100) / 100;
    }
}


// WEBPACK FOOTER //
// ./src/providers/data-management.service.ts